import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class DeleteProjectMutation extends Mutation {
  document = gql`
    mutation deleteProject($id: ID) {
      deleteProject(where: { id: $id }) {
        id
      }
    }
  `;
}
